import axiosInstance from "../../../components/authentication/helper/axiosApi";
import { ActionTypes } from "../../constants/action-types";

export const fetchCountriesAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/countries/`);

            dispatch({
                type: ActionTypes.SET_COUNTRIES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const fetchSectorAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/sector/`);

            dispatch({
                type: ActionTypes.SET_SECTORS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addSectorAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/sector/`, data);

            dispatch({
                type: ActionTypes.ADD_SECTORS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateSectorAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/sector/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_SECTORS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteSectorAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/sector/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_SECTORS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchStatutoryIndustryAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/statutoryTraining/`);

            dispatch({
                type: ActionTypes.SET_STATUTORY_INDUSTRY,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addStatutoryIndustryAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/statutoryTraining/`, data);

            dispatch({
                type: ActionTypes.ADD_STATUTORY_INDUSTRY,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateStatutoryIndustryAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/statutoryTraining/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_STATUTORY_INDUSTRY,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteStatutoryIndustryAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/statutoryTraining/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_STATUTORY_INDUSTRY,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchPhasesAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/phase/`);

            dispatch({
                type: ActionTypes.SET_PHASES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addPhasesAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/phase/`, data);

            dispatch({
                type: ActionTypes.ADD_PHASES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updatePhasesAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/phase/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_PHASES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deletePhasesAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/phase/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_PHASES,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchOrganisationAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/organisation/`);

            dispatch({
                type: ActionTypes.SET_ORGANISATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addOrganisationAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/organisation/`, data);

            dispatch({
                type: ActionTypes.ADD_ORGANISATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateOrganisationAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/organisation/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_ORGANISATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteOrganisationAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/organisation/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_ORGANISATIONS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchCompetenciesScoreAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/competenciesScore/`);

            dispatch({
                type: ActionTypes.SET_COMPETENCIES_SCORE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addCompetenciesScoreAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/competenciesScore/`, data);

            dispatch({
                type: ActionTypes.ADD_COMPETENCIES_SCORE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateCompetenciesScoreAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/competenciesScore/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_COMPETENCIES_SCORE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteCompetenciesScoreAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/competenciesScore/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_COMPETENCIES_SCORE,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchPersonalSkillsAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/personalSkills/`);

            dispatch({
                type: ActionTypes.SET_PERSONAL_SKILLS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addPersonalSkillsAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/personalSkills/`, data);

            dispatch({
                type: ActionTypes.ADD_PERSONAL_SKILLS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};


export const updatePersonalSkillsAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/personalSkills/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_PERSONAL_SKILLS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};


export const deletePersonalSkillsAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/personalSkills/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_PERSONAL_SKILLS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchQualificationsAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/qualification/`);

            dispatch({
                type: ActionTypes.SET_QUALIFICATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addQualificationsAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/qualification/`, data);

            dispatch({
                type: ActionTypes.ADD_QUALIFICATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateQualificationsAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/qualification/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_QUALIFICATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteQualificationsAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/qualification/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_QUALIFICATIONS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchEducationsAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/educationQualification/`);

            dispatch({
                type: ActionTypes.SET_EDUCATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};


export const addEducationsAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/educationQualification/`, data);

            dispatch({
                type: ActionTypes.ADD_EDUCATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};


export const updateEducationsAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/educationQualification/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_EDUCATIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};


export const deleteEducationsAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/educationQualification/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_EDUCATIONS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchFunctionsAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/function/`);

            dispatch({
                type: ActionTypes.SET_FUNCTIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addFunctionsAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/function/`, data);

            dispatch({
                type: ActionTypes.ADD_FUNCTIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateFunctionsAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/function/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_FUNCTIONS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteFunctionsAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/function/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_FUNCTIONS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchCategoryAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/category/`);

            dispatch({
                type: ActionTypes.SET_CATEGORYS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addCategoryAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/category/`, data);

            dispatch({
                type: ActionTypes.ADD_CATEGORYS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateCategoryAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/category/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_CATEGORYS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteCategoryAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/category/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_CATEGORYS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchJobTitlesAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/jobTitle/`);

            dispatch({
                type: ActionTypes.SET_JOB_TITLES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addJobTitlesAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/jobTitle/`, data);

            dispatch({
                type: ActionTypes.ADD_JOB_TITLES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateJobTitlesAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/jobTitle/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_JOB_TITLES,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteJobTitlesAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/jobTitle/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_JOB_TITLES,
                payload: id,
            });

        } catch (error) {

        }
    }
};
export const fetchJobTitlesGrade = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/grade/`);
            dispatch({
                type: ActionTypes.SET_GRADE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addJobTitlesGrade = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/grade/`, data);

            dispatch({
                type: ActionTypes.ADD_GRADE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateJobTitlesGrade = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/grade/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_GRADE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteJobTitlesGrade = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/grade/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_GRADE,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchRegion = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/region/`);
            dispatch({
                type: ActionTypes.SET_REGION,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addRegion = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/region/`, data);

            dispatch({
                type: ActionTypes.ADD_REGION,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateRegion = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/region/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_REGION,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteRegion = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/region/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_REGION,
                payload: id,
            });

        } catch (error) {

        }
    }
};


export const fetchSystemAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/system/`);

            dispatch({
                type: ActionTypes.SET_SYSTEMS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addSystemAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/system/`, data);

            dispatch({
                type: ActionTypes.ADD_SYSTEMS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateSystemAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/system/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_SYSTEMS,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteSystemAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/system/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_SYSTEMS,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchSystemExperienceAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/systemsExperience/`);

            dispatch({
                type: ActionTypes.SET_SYSTEM_EXPEREINCE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const addSystemExperienceAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/systemsExperience/`, data);

            dispatch({
                type: ActionTypes.ADD_SYSTEM_EXPEREINCE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateSystemExperienceAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/systemsExperience/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_SYSTEM_EXPEREINCE,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteSystemExperienceAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/systemsExperience/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_SYSTEM_EXPEREINCE,
                payload: id,
            });

        } catch (error) {

        }
    }
};

export const fetchSystemsExpereinceScoringAction = () => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.get(`/api/systemsExperienceAssessmentScoring/`);

            dispatch({
                type: ActionTypes.SET_SYSTEM_EXPEREINCE_SCORING,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};


export const addSystemsExpereinceScoringAction = (data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.post(`/api/systemsExperienceAssessmentScoring/`, data);

            dispatch({
                type: ActionTypes.ADD_SYSTEM_EXPEREINCE_SCORING,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const updateSystemsExpereinceScoringAction = (id, data) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.put(`/api/systemsExperienceAssessmentScoring/${id}/`, data);

            dispatch({
                type: ActionTypes.UPDATE_SYSTEM_EXPEREINCE_SCORING,
                payload: response.data,
            });

        } catch (error) {

        }
    }
};

export const deleteSystemsExpereinceScoringAction = (id) => {
    return async (dispatch) => {
        try {
            const response = await axiosInstance.delete(`/api/systemsExperienceAssessmentScoring/${id}/`);

            dispatch({
                type: ActionTypes.DELETE_SYSTEM_EXPEREINCE_SCORING,
                payload: id,
            });

        } catch (error) {

        }
    }
};